import DoubleStickyButton from './doubleStickyButton'

$('.js__doubleStickyButton').each((_, el) => {
  const $el = $(el)
  const props = JSON.parse($el.attr('data-options'))

  $el.reactify(DoubleStickyButton, props)
  $el.children().unwrap()
})
